import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "menu-points border-bottom"
};
const _hoisted_2 = {
  class: "d-flex align-items-start my-2"
};
const _hoisted_3 = {
  key: 0,
  class: "me-2"
};
const _hoisted_4 = {
  class: "ms-2"
};
const _hoisted_5 = {
  class: "form-check form-switch"
};
const _hoisted_6 = ["title"];
const _hoisted_7 = {
  class: "form-check form-switch ms-2"
};
const _hoisted_8 = ["onUpdate:modelValue", "disabled", "onInput", "title"];
const _hoisted_9 = {
  key: 2,
  class: "bg-soft-primary rounded my-2"
};
const _hoisted_10 = {
  class: "form-check form-switch ms-2"
};
const _hoisted_11 = ["onUpdate:modelValue", "disabled", "onInput", "title"];
const _hoisted_12 = {
  class: "form-check form-switch ms-2"
};
const _hoisted_13 = ["onUpdate:modelValue", "disabled", "onInput", "title"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_auth_menu_point_list = _resolveComponent("auth-menu-point-list");
  const _component_BOverlay = _resolveComponent("BOverlay");
  return _openBlock(), _createElementBlock("li", _hoisted_1, [_createElementVNode("div", _hoisted_2, [$props.modelValue.icon ? (_openBlock(), _createElementBlock("span", _hoisted_3, [_createElementVNode("i", {
    class: _normalizeClass($props.modelValue.icon)
  }, null, 2)])) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString($props.modelValue.translation_key ? _ctx.$t($props.modelValue.translation_key).ucFirst() : $props.modelValue.name), 1), _createElementVNode("span", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.individualValue = $event),
    class: _normalizeClass([{
      'fantom-checked': $options.individual && $props.modelValue.role_group_value
    }, "form-check-input"]),
    type: "checkbox",
    onInput: _cache[1] || (_cache[1] = (...args) => $options.setIndividualValue && $options.setIndividualValue(...args)),
    title: $props.modelValue.role_group_value ? _ctx.$t('authorization::authorization.granted_by_group').ucFirst() : ''
  }, null, 42, _hoisted_6), [[_vModelCheckbox, _ctx.individualValue]])])]), $props.modelValue.is_customizable && $props.modelValue.role_category ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass({
      'opacity-50': !_ctx.individualValue
    })
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.modelValue.role_category.custom_roles, (role, rKey) => {
    return _openBlock(), _createElementBlock("div", {
      key: rKey,
      class: "d-inline-flex ms-4"
    }, [role.icon ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      class: "me-2",
      style: _normalizeStyle({
        color: role.color
      })
    }, [_createElementVNode("i", {
      class: _normalizeClass(role.icon)
    }, null, 2)], 4)) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(role.translation_key ? _ctx.$t(role.translation_key).ucFirst() : role.name), 1), _createElementVNode("div", _hoisted_7, [_withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": $event => role[$props.valueProperty] = $event,
      disabled: !_ctx.individualValue,
      class: _normalizeClass([{
        'fantom-checked': $options.individual && role.role_group_value
      }, "form-check-input"]),
      type: "checkbox",
      onInput: event => $options.setRoleIndividualValue(event.target.checked, rKey, 'custom_roles'),
      title: role.role_group_value ? _ctx.$t('authorization::authorization.granted_by_group').ucFirst() : ''
    }, null, 42, _hoisted_8), [[_vModelCheckbox, role[$props.valueProperty]]])])]);
  }), 128))], 2)) : _createCommentVNode("", true), $props.modelValue.is_crud && $props.modelValue.role_category ? (_openBlock(), _createElementBlock("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.modelValue.role_category.crud_roles, (role, rKey) => {
    return _openBlock(), _createElementBlock("div", {
      key: rKey,
      class: "d-inline-flex ms-4"
    }, [role.icon ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      class: "me-2",
      style: _normalizeStyle({
        color: role.color
      })
    }, [_createElementVNode("i", {
      class: _normalizeClass(role.icon)
    }, null, 2)], 4)) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(role.authority_translation_key ? _ctx.$t(role.authority_translation_key).ucFirst() : role.authority), 1), _createElementVNode("div", _hoisted_10, [_withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": $event => role[$props.valueProperty] = $event,
      disabled: !_ctx.individualValue,
      class: _normalizeClass([{
        'fantom-checked': $options.individual && role.role_group_value
      }, "form-check-input"]),
      type: "checkbox",
      onInput: event => $options.setRoleIndividualValue(event.target.checked, rKey, 'crud_roles'),
      title: role.role_group_value ? _ctx.$t('authorization::authorization.granted_by_group').ucFirst() : ''
    }, null, 42, _hoisted_11), [[_vModelCheckbox, role[$props.valueProperty]]])])]);
  }), 128)), $props.modelValue.role_category.basic_roles ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($props.modelValue.role_category.basic_roles, (role, rKey) => {
    return _openBlock(), _createElementBlock("div", {
      key: rKey,
      class: "d-inline-flex ms-4"
    }, [role.icon ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      class: "me-2",
      style: _normalizeStyle({
        color: role.color
      })
    }, [_createElementVNode("i", {
      class: _normalizeClass(role.icon)
    }, null, 2)], 4)) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(role.authority_translation_key ? _ctx.$t(role.authority_translation_key).ucFirst() : role.authority), 1), _createElementVNode("div", _hoisted_12, [_withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": $event => role[$props.valueProperty] = $event,
      disabled: !_ctx.individualValue,
      class: _normalizeClass([{
        'fantom-checked': $options.individual && role.role_group_value
      }, "form-check-input"]),
      type: "checkbox",
      onInput: event => $options.setRoleIndividualValue(event.target.checked, rKey, 'basic_roles'),
      title: role.role_group_value ? _ctx.$t('authorization::authorization.granted_by_group').ucFirst() : ''
    }, null, 42, _hoisted_13), [[_vModelCheckbox, role[$props.valueProperty]]])])]);
  }), 128)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), _createVNode(_component_BOverlay, {
    show: !$options.show,
    "no-spinner": ""
  }, {
    default: _withCtx(() => [$props.modelValue.menu_points?.length ? (_openBlock(), _createBlock(_component_auth_menu_point_list, {
      key: 0,
      modelValue: $props.modelValue.menu_points,
      "onUpdate:modelValue": $options.updateModelValue,
      valueProperty: $props.valueProperty
    }, null, 8, ["modelValue", "onUpdate:modelValue", "valueProperty"])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["show"])]);
}